export const riskLevel = {
  0: "very low",
  1: "low",
  2: "moderate",
  3: "elevated",
  4: "high",
  5: "very high",
};
